import * as React from 'react';
import { observer } from 'mobx-react-lite';
import InfoBarViewState from '../schema/InfoBarViewState';
import InfoBarMessage from './InfoBarMessage';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';

export interface InfoBarProps extends InfoBarViewState {
    className?: string;
    textContainerClassName?: string;
    colorScheme?: ColorScheme;
}

const InfoBar = observer(function InfoBar(props: InfoBarProps) {
    // VSO 1777: add collapse/expand behavior to info bar
    // VSO 1778: sort info messages in info bar based on ranks
    return props.messages.length > 0 ? (
        <div className={props.className} key="infoBarDiv">
            {props.messages.map(message => (
                <InfoBarMessage
                    key={message.key}
                    textContainerClassName={props.textContainerClassName}
                    colorScheme={props.colorScheme}
                    {...message}
                />
            ))}
        </div>
    ) : null;
});
export default InfoBar;
